import React from 'react';
import { Descriptions } from 'antd';
import Vehicle from '../../../core/models/Vehicle';
import { formatDateTime } from '../../../utils/dateTimeUtil';

interface IProps {
  column: number;
  vehicle: Vehicle | null;
}

const ViewVehicleSummery: React.FC<IProps> = ({ column, vehicle }: IProps) => {
  return (
    <Descriptions
      size='small'
      column={column}
      layout='horizontal'
      labelStyle={{ fontWeight: 'bold' }}
    >
      <Descriptions.Item label='Created On'>
        {formatDateTime(vehicle?.createdDate)}
      </Descriptions.Item>
      <Descriptions.Item label='Last Updated On'>
        {formatDateTime(vehicle?.updatedDate)}
      </Descriptions.Item>
    </Descriptions>
  );
};

export default ViewVehicleSummery;
